'use client';

import { faMessageQuestion } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { AppointmentType } from '@/types/enums/appointments.enum';
import { patientSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { phonePatientSac } from '@/utils/consts/sac.consts';

interface AppointmentUnconfirmedSupportProps {
  appointmentType: AppointmentType;
}

export function AppointmentUnconfirmedSupport({ appointmentType }: AppointmentUnconfirmedSupportProps) {
  const { url } = useWhatsappLinkWithAnalytics(phonePatientSac, patientSacWhatsappMessage);

  return (
    <div
      data-testid={DataTestIdEnum.APPOINTMENT_CARD_UNCONFIRMED_SUPPORT}
      className="flex flex-col gap-4 border border-success-300 rounded-xxl p-4"
    >
      <Typography variant={TypographyVariant.BODY_TEXT} className="text-lg font-bold text-gray-900">
        Precisa de ajuda?
      </Typography>
      <Typography>O local não confirmou se você foi atendido. Se precisar, fale com a gente:</Typography>
      <Button asChild startIcon={faMessageQuestion} variant="secondary">
        <Link
          prefetch={false}
          href={url}
          target="_blank"
          data-testid={DataTestIdEnum.APPOINTMENT_CARD_UNCONFIRMED_SUPPORT_BUTTON}
          data-analytics-event={AnalyticsEnum.MY_APPOINTMENTS_CLICK_UNCONFIRMED_HELP}
          data-analytics-properties={JSON.stringify({ tipo_agendamento: appointmentType })}
        >
          Preciso de ajuda
        </Link>
      </Button>
    </div>
  );
}
